export default "__VITE_ASSET__BtFZ_cfQ__"